import { createContext, useContext } from 'react'

interface ClientTabFocus {
  flashedCardId: string | null
  focusCard: (anchorId: string, cardId: string) => void
}

export const ClientTabFocusContext = createContext<ClientTabFocus>({
  flashedCardId: null,
  focusCard: () => undefined,
})

export const useClientTabFocus = () => useContext(ClientTabFocusContext)
